import { $f } from '@/core/services/formatter';
export default {
    install: (app) => {
        app.config.globalProperties.$case = (value, casing) => {
            return $f.case(value, casing);
        };
    },
};
